import { createInstance } from "@hackler/react-sdk";
import {
  HACKLE_DEVTOOLS_STORAGE_KEY,
  HACKLE_VARIATIONS,
  registerExperiment,
} from "../components/GoiHackleDevtools";

export const HackleClient = createInstance(
  process.env.NEXT_PUBLIC_HACKLE_BROWSER_SDK_KEY as string
);

type VariationMap = Record<number, string>;

const isDevEnvironment = (): boolean => {
  const isDevelopment = process.env.NODE_ENV === "development";
  const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";
  const isProductionExplicitlySet =
    process.env.NEXT_PUBLIC_IS_PRODUCTION === "true";
  return (isDevelopment || isPreview) && !isProductionExplicitlySet;
};

/**
 * 이벤트 핸들러 등 React 렌더 사이클 밖에서 Hackle variation을 조회하는 함수.
 * useCustomVariation(hook)과 달리 원하는 시점에 호출 가능하여,
 * 노출 이벤트 발생 시점을 제어할 수 있다.
 *
 * - Dev 환경: GoiHackleDevtools localStorage 오버라이드 지원
 * - Production: HackleClient.variation() 직접 호출
 * - 동기 함수이므로 깜빡임(A→B 전환) 없이 즉시 올바른 값 반환
 *
 * @param experimentKey - 실험 키
 */
export const getVariationOnDemand = (experimentKey: number): string => {
  if (typeof window !== "undefined" && isDevEnvironment()) {
    registerExperiment(experimentKey);

    const stored = window.localStorage.getItem(HACKLE_DEVTOOLS_STORAGE_KEY);
    if (stored) {
      try {
        const variations: VariationMap = JSON.parse(stored);
        const testVariation = variations[experimentKey];

        if (HACKLE_VARIATIONS.includes(testVariation as any)) {
          return testVariation;
        }
      } catch {
        // ignore
      }
    }
  }

  return HackleClient.variation(experimentKey);
};
